// extracted by mini-css-extract-plugin
export default {"card":"AntiNuke_card__5C40M","block":"AntiNuke_block__v3XF8"};